import { setDevicesInventoryData } from "stores/slice/bogus/devices/const";
import {
  setSonicosAdoptRequest,
  setSonicosDiscoveryRequest,
} from "stores/slice/bogus/devices/addDevice/sonicosDiscovery";

const addDevicesConfig = {
  /** Inform Host **/
  "/orgs/settings/informHost.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/informHost",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceInformHost",
  },
  /** Sites **/
  "/ents/orgs/sites.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceSites",
  },
  "/orgs/sites.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceSites",
  },
  /** Inventory **/
  "/ents/orgs/devices/inventory.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  "/ents/orgs/sites/devices/inventory.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  "/orgs/devices/inventory.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  "/orgs/sites/devices/inventory.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/inventory",
    restful: true,
    method: "read",
    buildParams: null,
    action: setDevicesInventoryData,
    mockSelector: "devices.selecterDevicesData",
  },
  /** Inventory Device Account **/
  "/ents/orgs/settings/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/inventoryDeviceAccount",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceInventoryDeviceAccount",
  },
  "/orgs/settings/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/settings/inventoryDeviceAccount",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceInventoryDeviceAccount",
  },
  "/ents/orgs/sites/devices/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/inventoryDeviceAccount",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceInventoryDeviceAccount",
  },
  "/orgs/sites/devices/inventoryDeviceAccount.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/inventoryDeviceAccount",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceInventoryDeviceAccount",
  },
  /** Devices Account **/
  "/ents/orgs/sites/settings/deviceAccount.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  "/orgs/sites/settings/deviceAccount.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/deviceAccount",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceDeviceAccount",
  },
  /** Existing Devices **/
  "/ents/orgs/existedDevices.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceOrgDevices",
  },
  "/orgs/existedDevices.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceOrgDevices",
  },
  "/ents/orgs/sites/existedDevices.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceSiteDevices",
  },
  "/orgs/sites/existedDevices.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "addDeviceSiteDevices",
  },
  /** Discovery **/
  "/ents/orgs/devices/provision/discovery.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosDiscoveryRequest,
    mockHandler: ({ state, params }) => (params.discoveryProtocol === "sonicos"
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceDiscoveredOrgDevices),
  },
  "/orgs/devices/provision/discovery.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosDiscoveryRequest,
    mockHandler: ({ state, params }) => (params.discoveryProtocol === "sonicos"
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceDiscoveredOrgDevices),
  },
  "/ents/orgs/sites/devices/provision/discovery.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosDiscoveryRequest,
    mockHandler: ({ state, params }) => (params.discoveryProtocol === "sonicos"
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceDiscoveredSiteDevices),
  },
  "/orgs/sites/devices/provision/discovery.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosDiscoveryRequest,
    mockHandler: ({ state, params }) => (params.discoveryProtocol === "sonicos"
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceDiscoveredSiteDevices),
  },
  "/ents/orgs/devices/provision/surveillanceDiscovery.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceDiscoveredDevices",
  },
  "/orgs/devices/provision/surveillanceDiscovery.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceDiscoveredDevices",
  },
  "/ents/orgs/sites/devices/provision/surveillanceDiscovery.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceDiscoveredDevices",
  },
  "/orgs/sites/devices/provision/surveillanceDiscovery.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceDiscoveredDevices",
  },
  /** Stop Discovery **/
  "/ents/orgs/devices/provision/stop.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceStopDiscoveryOrgDevices",
  },
  "/orgs/devices/provision/stop.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceStopDiscoveryOrgDevices",
  },
  "/ents/orgs/sites/devices/provision/stop.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceStopDiscoverySiteDevices",
  },
  "/orgs/sites/devices/provision/stop.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/discovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceStopDiscoverySiteDevices",
  },
  "/ents/orgs/devices/provision/surveillanceStop.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceStopDiscovery",
  },
  "/orgs/devices/provision/surveillanceStop.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceStopDiscovery",
  },
  "/ents/orgs/sites/devices/provision/surveillanceStop.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceStopDiscovery",
  },
  "/orgs/sites/devices/provision/surveillanceStop.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/surveillanceDiscovery",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceStopDiscovery",
  },
  /** Authentication **/
  "/ents/orgs/devices/provision/authenticate.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/authenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceAuthenticatedOrgDevices",
  },
  "/orgs/devices/provision/authenticate.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/authenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceAuthenticatedOrgDevices",
  },
  "/ents/orgs/sites/devices/provision/authenticate.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/authenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceAuthenticatedSiteDevices",
  },
  "/orgs/sites/devices/provision/authenticate.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/authenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceAuthenticatedSiteDevices",
  },
  "/ents/orgs/devices/provision/surveillanceAuthenticate.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/surveillanceAuthenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAuthenticatedDevices",
  },
  "/orgs/devices/provision/surveillanceAuthenticate.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/surveillanceAuthenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAuthenticatedDevices",
  },
  "/ents/orgs/sites/devices/provision/surveillanceAuthenticate.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/surveillanceAuthenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAuthenticatedDevices",
  },
  "/orgs/sites/devices/provision/surveillanceAuthenticate.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/surveillanceAuthenticate",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAuthenticatedDevices",
  },
  /** IP Settings **/
  "/ents/orgs/devices/provision/ipSetting.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/ipSetting",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceIpSettingOrgDevices",
  },
  "/orgs/devices/provision/ipSetting.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/ipSetting",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceIpSettingOrgDevices",
  },
  "/ents/orgs/sites/devices/provision/ipSetting.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/ipSetting",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceIpSettingSiteDevices",
  },
  "/orgs/sites/devices/provision/ipSetting.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/ipSetting",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceIpSettingSiteDevices",
  },
  /** Adopt **/
  "/ents/orgs/devices/provision/adopt.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/adopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosAdoptRequest,
    mockHandler: ({ state, params }) => (params.devices?.some((device) => device.protocolType === "sonicos")
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceAdoptOrgDevices),
  },
  "/orgs/devices/provision/adopt.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/adopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosAdoptRequest,
    mockHandler: ({ state, params }) => (params.devices?.some((device) => device.protocolType === "sonicos")
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceAdoptOrgDevices),
  },
  "/ents/orgs/sites/devices/provision/adopt.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/adopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosAdoptRequest,
    mockHandler: ({ state, params }) => (params.devices?.some((device) => device.protocolType === "sonicos")
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceAdoptSiteDevices),
  },
  "/orgs/sites/devices/provision/adopt.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/adopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: setSonicosAdoptRequest,
    mockHandler: ({ state, params }) => (params.devices?.some((device) => device.protocolType === "sonicos")
      ? state.addDeviceSonicosDiscovery
      : state.addDeviceAdoptSiteDevices),
  },
  "/ents/orgs/devices/provision/surveillanceAdopt.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/surveillanceAdopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAdoptDevices",
  },
  "/orgs/devices/provision/surveillanceAdopt.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/surveillanceAdopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAdoptDevices",
  },
  "/ents/orgs/sites/devices/provision/surveillanceAdopt.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/devices/provision/surveillanceAdopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAdoptDevices",
  },
  "/orgs/sites/devices/provision/surveillanceAdopt.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/devices/provision/surveillanceAdopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDeviceSurveillanceAdoptDevices",
  },
  /** Pre-Register **/
  "/ents/orgs/devices/provision/cloudAdopt.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/devices/provision/cloudAdopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDevicePreRegisterOrgDevices",
  },
  "/orgs/devices/provision/cloudAdopt.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/devices/provision/cloudAdopt",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "addDevicePreRegisterOrgDevices",
  },
  /** Pre-Confirm Service Change **/
  "/ents/orgs/license/service/subscribe/preConfirm": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/license/device/preConfirm",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "license.licensePreConfirm",
  },
  "/orgs/license/service/subscribe/preConfirm": {
    protocol: "ws",
    resource: "/orgs/:orgId/license/device/preConfirm",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "license.licensePreConfirm",
  },
}

export default addDevicesConfig;
